// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"16064f38","703":"0b957f6d","787":"df54f7d0"}[chunkId] + ".chunk.js";
};